import HashListener from "/WebInterface/new-ui/modules/hash-listener.js";
import { growl } from "/WebInterface/new-ui/modules/toast.js";
import { Confirm } from "/WebInterface/new-ui/modules/alert.js";
import { initSharing } from "/WebInterface/new-ui/modules/modals/sharing/sharing.js";
import Modal from "/WebInterface/new-ui/modules/modal.js";
import downloadingQueue from "/WebInterface/new-ui/modules/advanced-download/downloading-queue.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import store from "/WebInterface/new-ui/store/index.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import userActions from "/WebInterface/new-ui/assets/js/app/user-actions.js";
import {
  showCustomUploadFormModal,
  updateCustomUploadFormModal,
  updateCustomForm,
  isCustomUploadFormAvailable,
  showCommonUploadForm,
} from "/WebInterface/new-ui/upload/modules/upload-form/upload-form.js";
import { getCustomForm } from "/WebInterface/new-ui/assets/js/utils/api/apis.js";
import { validate } from "/WebInterface/new-ui/assets/js/utils/validate.js";
import { fileTypes } from "/WebInterface/new-ui/assets/js/constants.js";

// Initialize Hash Listener
const hashListener = new HashListener({});

// Declare uploadModal for later use
let uploadModal;

// Function to show the upload modal
export const onShowUploadModal = () => {
  if (uploadModal && !uploadModal.visible()) {
    uploadModal.show(true);
  }
};

export const showUploadModalAndListFiles = (files) => {
  if (uploadModal && !uploadModal.visible()) {
    uploadModal.show(true);
  }

  const iframe = _$("#fileUploadIframe").el();
  iframe?.contentWindow?.postMessage({
    key: "addFilesToQueue",
    value: files,
  });
};

// Middleware function for loading new upload iframe
export const loadNewUploadIFrameMiddleWare = async () => {
  const { privs } = store?.currentDirectoryInfo;
  if (!privs?.includes("(write)")) {
    let isDraggingCrushFTPItem = false;

    _$("body").on("dragstart", () => {
      isDraggingCrushFTPItem = true;
    });

    _$("body").on("drop", (e) => {
      e.preventDefault();
      if (
        !e.dataTransfer ||
        !e.dataTransfer.files ||
        e.dataTransfer.files.length === 0
      )
        return;

      if (!isDraggingCrushFTPItem) {
        growl(
          t("youDoNotHavePermissionToUpload"),
          t("uploadNotAllowed"),
          5000,
          true
        );
      }
    });
  }

  const isElectronUploadOnlyApp = utils.isElectron();

  // const initialUploadModalWidth =
  //   store.userInfo.userCustomizations?.["upload_UploadPanelDefaultWidth"]
  //     ?.value;

  // Create upload modal
  uploadModal = new Modal({
    title: "filesToUpload",
    body: `<div class="w-full h-full">
    <iframe
      class="w-full h-full"
      frameborder="0"
      id="fileUploadIframe"
      src="/WebInterface/new-ui/upload/index.html?embed=true"></iframe>
  </div>`,
    animate: false,
    show: isElectronUploadOnlyApp, // If Electron App
    backdrop: false,
    movable: !isElectronUploadOnlyApp,
    closable: isElectronUploadOnlyApp,
    hasFooter: false,
    showHeader: !isElectronUploadOnlyApp,
    destroyOnClose: false,
    uniqueId: "UI_Upload_NEW",
    extraClasses: ["files-to-upload-modal"],
    minWidth: "921px",
    minHeight: "700px",
    onAfterShow: () => {
      const overrideFontFamily = utils.getUserCustomizationValue(
        "fontFace",
        true
      );

      const iframe = _$("#fileUploadIframe").el();
      iframe?.addEventListener("load", () => {
        iframe.contentWindow.postMessage({
          key: "overrideFontFamily",
          value:
            overrideFontFamily ||
            'BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif',
        });
      });
    },
    // initialWidth: `${initialUploadModalWidth}px`,
  });

  // if (isElectronUploadOnlyApp) {
  // _$(uploadModal?.modal?.body).addClass("py-2");
  // _$(uploadModal?.modal?.body).addClass("px-1");
  // }

  const { customUploadForm, customCommonUploadForm, currentDirectoryInfo } =
    store;

  if (!customUploadForm) {
    try {
      const customUploadForm = await getCustomForm("uploadForm");
      store.dispatch("setCustomUploadForm", customUploadForm);
    } catch (error) {
      // console.log(error);
    }
  }

  if (!customCommonUploadForm?.formDetails) {
    try {
      const customCommonUploadForm = await getCustomForm("commonUploadForm");
      store.dispatch("setCustomCommonUploadForm", customCommonUploadForm);
    } catch (error) {
      // console.log(error);
    }
  }

  // Drag and drop related events
  let isDraggingCrushFTPItem = false;

  const disableDragAndDropUpload = utils.getUserCustomizationValue(
    "disableDragDropUpload"
  );

  if (
    !disableDragAndDropUpload &&
    !(
      currentDirectoryInfo.privs.includes("(locked)") &&
      currentDirectoryInfo.privs.includes("(expired)")
    )
  ) {
    window.addEventListener("dragover", (e) => {
      e.preventDefault();
      const { privs } = store?.currentDirectoryInfo;
      if (!privs?.includes("(write)")) {
        let isDraggingCrushFTPItem = false;

        _$("body").on("dragstart", () => {
          isDraggingCrushFTPItem = true;
        });

        _$("body").on("drop", (e) => {
          e.preventDefault();
          if (
            !e.dataTransfer ||
            !e.dataTransfer.files ||
            e.dataTransfer.files.length === 0
          )
            return;

          if (!isDraggingCrushFTPItem) {
            growl(
              t("youDoNotHavePermissionToUpload"),
              t("uploadNotAllowed"),
              5000,
              true
            );
          }
        });
        return false;
      }

      if (!isDraggingCrushFTPItem && !uploadModal.visible()) {
        userActions.invoke({
          name: "performAction('upload')",
          draggingEvent: true,
        });
      }
    });

    window.addEventListener("dragstart", () => {
      isDraggingCrushFTPItem = true;
    });

    window.addEventListener("dragend", (e) => {
      e.preventDefault();
      isDraggingCrushFTPItem = false;
    });
  }

  window.isElectron = utils.isElectron;
  window.getIPCRenderer = utils.getIPCRenderer;

  window.getCurrentTheme = () => {
    const theme = _$("html").attr("data-theme");
    return theme;
  };

  window.getCurrentLanguage = () => {
    const lang = _$("html").attr("lang");
    return lang;
  };

  // Define functions accessible globally
  window.getDraggingItemIsFromCrushFTP = () => {
    return isDraggingCrushFTPItem;
  };

  window.currentPath = () => {
    let path = hashListener.getPath();
    try {
      path = decodeURIComponent(path);
    } catch (ex) {
      path = unescape(path);
    }
    return path;
  };

  window.uploadNotifications = (uploadConfig) => {
    if (window.parent.postMessage) {
      window.parent.postMessage(uploadConfig, "*");
    }
  };

  window.getBaseURL = () => {
    let baseURL = document.location.href + "";
    if (baseURL.indexOf("#") >= 0)
      baseURL = baseURL.substring(0, baseURL.indexOf("#"));

    const customShareLinkURL = utils.getUserCustomizationValue(
      "customShareLinkURL",
      true
    );

    if (customShareLinkURL) {
      baseURL = customShareLinkURL;
    }

    return baseURL;
  };

  window.showCustomUploadFormModal = showCustomUploadFormModal;
  window.updateCustomUploadFormModal = updateCustomUploadFormModal;
  window.updateCustomForm = updateCustomForm;
  window.isCustomUploadFormAvailable = isCustomUploadFormAvailable;
  window.showCommonUploadForm = showCommonUploadForm;
  window.validate = validate;

  window.growl = growl;

  window.currentHash = () => {
    return hashListener.getHash();
  };

  window.commonUploadForm = () => {
    const customCommonUploadForm = store?.customCommonUploadForm;
    return customCommonUploadForm;
  };

  window.currentDirPrivs = () => {
    const { privs } = store?.currentDirectoryInfo;
    return privs;
  };

  window.getCurrentDirInfo = () => {
    return store?.currentDirectoryInfo;
  };

  window.getCurrentTreeItems = () => {
    return utils.deepCopy(store.files);
  };

  window.refreshListing = () => {
    store.dispatch("refreshListing");
  };

  window.logout = () => {
    store.dispatch("logoutRequested");
  };

  window.getUserInfo = () => {
    return store.userInfo;
  };

  window.getMetaUserInfo = () => {
    const userInfo = store.userInfo;

    const metaUserInfo =
      Object.fromEntries(
        Object.entries(userInfo).filter(([key]) => key.startsWith("META_"))
      ) || {};
    return metaUserInfo;
  };

  window.getAlternateDomains = () => {
    const altHttpDomains = store.userInfo.alt_http_domains;
    const serverNames = [];

    if (typeof altHttpDomains !== "string") return serverNames;

    let altDomains = altHttpDomains
      ? altHttpDomains.replace("alt_http_domains", "")
      : "";

    if (!altDomains) return serverNames;

    let altArr = [];

    if (altDomains.indexOf(";") >= 0) altArr = altDomains.split(";");
    else altArr = altDomains.split("\n");

    const port = window.location.port;
    const protocol = window.location.protocol;

    altArr.forEach((item) => {
      let serverName = item;

      if (!serverName) return;
      serverName = serverName.replace("\n", "");

      if (
        !serverName.startsWith("http://") &&
        !serverName.startsWith("https://")
      )
        serverName = protocol + "//" + serverName;
      if (serverName.endsWith("/")) serverName = serverName.slice(0, -1);
      if (serverName.split(":").length < 3) {
        serverName += ":" + port;
      }

      serverNames.push(serverName);
    });

    return serverNames;
  };

  window.getUserCustomizationValue = (customizationType, value) => {
    return utils.getUserCustomizationValue(customizationType, value);
  };

  window.closeUploadModal = uploadModal.hide;

  window.initSharing = initSharing;

  window.initQuickSharing = (files) => {
    const fileListContext = files.paths
      .split("\r\n")
      .map((file) => ({ href_path: file, type: fileTypes.FILE }));
    userActions.invoke({
      name: "quickShare",
      context: fileListContext,
    });
  };

  window.confirmAlert = Confirm;

  window.setUploadingStatus = (type, status) => {
    store.dispatch("setChunkProcessingStatus", {
      type,
      status,
    });
  };

  window.checkForAutoUpload = () => {
    const isElectronUploadOnlyApp = utils.isElectron();
    return (
      isElectronUploadOnlyApp || store?.userOptions?.preference?.autoStartUpload
    );
  };

  window.getDownloadStatus = () => {
    const { isDownloading } = store.chunkProcessingStatus;
    return isDownloading;
  };

  window.titleAlert = (message, duration) => {
    utils.titleAlert(message, duration);
  };

  window.continueDownload = () => {
    if (downloadingQueue) downloadingQueue.continueDownload();
  };

  window.redirectPage = (location) => {
    window.location = location;
  };
};
